/**
 * 按需加载antd组件
 */
import Vue from 'vue'

// base library
import {
  Input,
  InputNumber,
  Button,
  Switch,
  Radio,
  Container,
  Header,
  Upload,
  Tooltip,
  Main,
  Aside,
  Form,
  FormItem,
  Select,
  Badge,
  Option,
  DatePicker,
  Table,
  TableColumn,
  Dialog,
  Tabs,
  TabPane,
  Loading,
  
} from 'element-ui'

Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Button)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(Container)
Vue.use(Header)
Vue.use(Upload)
Vue.use(Tooltip)
Vue.use(Main)
Vue.use(Aside)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Badge)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)

Vue.use(Loading.directive);